import { LazyImage } from '../LazyImage';
import { Skeleton } from '../Skeleton';
import { Text } from '../Text';
import styles from './mood.module.sass';
import cn from 'classnames';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    id?: string; // Optional when loading
    isLoading: true;
    title?: string; // Optional when loading
    image?: string; // Optional when loading
    onClickHandler?: (id: string) => void;
}

interface LoadedProps extends BaseProps {
    id: string; // Required when not loading
    isLoading?: false;
    title: string; // Required when not loading
    image: string; // Required when not loading
    onClickHandler?: (id: string) => void;
}

type MoodProps = LoadingProps | LoadedProps;

export const Mood = ({ id, title, image, isLoading, onClickHandler = () => undefined, ...props }: MoodProps) => {
    if (isLoading) {
        return (
            <div {...props} className={cn(styles.mood, props.className)}>
                <Skeleton absolute />
            </div>
        );
    }

    return (
        <div {...props} className={cn(styles.mood, props.className)} onClick={() => onClickHandler(id)}>
            <LazyImage src={image} className={styles.image} />
            <Text
                as="h2"
                variant="h2"
                alignment="start"
                margin="0"
                color="white"
                fontWeight="medium"
                className={styles.title}
                size={{ default: '18', md: '24' }}
            >
                {title}
            </Text>
        </div>
    );
};
